import React, { Fragment, useEffect } from 'react';
import ReactGA from 'react-ga4' ;

const ServiceDetailsPage = () => {
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Detalles del Servicio" });
      }, []);
    return (
        <Fragment>
            <div className="section-title position-relative text-center mx-auto mb-5 mt-5 pb-3" style={{ maxWidth: '600px' }}>
                <h1 className="display-4 text-uppercase font-title">Detalles del Servicio</h1>
            </div>
            <div className="container-fluid">
                <div className="container">
                    {/* <div className="section-title position-relative text-center mx-auto mb-5 pb-3" style={{ maxWidth: '600px' }}>
                        <h1 className="display-4 text-uppercase">¿Qué Ofrecemos?</h1>
                    </div> */}
                    <div className="row gx-5 mb-5">
                        <div className="col-lg-5 mb-5 mb-lg-0" style={{ minHeight: '400px' }}>
                            <div className="position-relative h-100">
                                <img className="position-absolute w-100 h-100" alt='' src={process.env.PUBLIC_URL + '/imgs/galeria/20220319/29.jpg'} style={{ objectFit: 'cover' }} />
                            </div>
                        </div>
                        <div className="col-lg-6  text-primary-2 text-justify">

                            <ul >
                                <li><p>Trabajo en conjunto con la pareja en la creación del ritual: Incluye primera entrevista y dos reuniones de preparación y coordinación.</p></li>
                                <li><p>Acompañamiento en el proceso de tareas solicitadas a la pareja: se establecen plazos de entrega y se explica a cabalidad el objetivo de cada tarea asignada, además de realizar seguimiento personalizado del proceso previo a la ceremonia.</p></li>
                                <li><p>Producción y coordinación de la ceremonia previo al día del evento, luego de planificar los detalles de la ceremonia de unión junto a la pareja: confección del guión ceremonial , diseño del altar, reunión con dj, reunión con  músicos, contacto con productora del evento, etc.</p></li>
                                <li><p>Producción y coordinación de la ceremonia el día del evento:</p>
                                    <ul>
                                        <li>
                                            <p>Guía y asistencia a los invitados.</p>
                                        </li>
                                        <li>
                                            <p>Entrega de pauta de guión y coordinación de los participantes de la ceremonia según corresponda. (dj, fotógrafos, familia/amigos, músicos, etc).</p>
                                        </li>
                                        <li>
                                            <p>Acompañamiento continua a la pareja durante toda la jornada (aromaterapia, repaso breve de hitos importantes, apoyo y asistencia de instrumentos ceremoniales, etc).</p>
                                        </li>
                                        <li>
                                            <p>El día de la ceremonia acude el equipo completo de Elemental , más asistentes de ser necesarios.</p>
                                        </li>
                                    </ul>
                                </li>
                                <li><p>Entrega de bolsa de regalo con recuerdos de la ceremonia : Incluye guión, ficha de la pareja, velón, sahumos utilizados, etc. </p></li>
                                <li><p>Decoración del Altar : (Solo mesa) Incluye todos los elementos utilizados en la ceremonia y flores naturales.</p></li>
                            </ul>
                        </div>


                    </div>
                    <div className="row gx-5">
                        <div className="col-lg-12 text-primary-2 text-justify">
                            <h4 className='text-uppercase mt-4'>Servicios Complementarios</h4>
                            <ul >
                                
                                <li><p>Amplificación de sonido.</p> </li>
                                <li><p>Ensayo de ceremonia.</p> </li>
                                <li><p>Cronograma impreso del viaje ceremonial para invitados. Incluye, por ejemplo: canción de los novios, frases importantes de la ceremonia, etc.</p> </li>
                                <li><p>Ritual de meditación y preparación pre-boda.</p> </li>
                                <li><p>Cualquier rito agregado que no se incluya dentro del cuestionario de la ceremonia Elemental (Ceremonia Estándar)</p> </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row gx-5 mt-5">
                        <div className="col-lg-12 text-primary-2 text-justify font-weight-bold">
                            <p>(*) Las ceremonias realizadas fuera del anillo de Avenida Américo Vespucio y/u otras regiones, tendrán un costo adicional de traslado.</p> 
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ServiceDetailsPage;